//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Menu from '../../../../components/menu/index.js';

export default {
  extends: Menu,
};
